export type SignInSkin = {
  label: string;
  input: string;
  inputError: string;
  primaryButton: string;
  linkButton: string;
  error: string;
  divider: string;
};

export const DEFAULT_SIGN_IN_SKIN: SignInSkin = {
  label: "block text-sm font-medium text-neutral-700 dark:text-neutral-300",
  input:
    "w-full rounded-lg border border-neutral-300 bg-white px-3 py-2 text-neutral-900 placeholder-neutral-400 focus:border-emerald-500 focus:outline-none focus:ring-2 focus:ring-emerald-500 disabled:cursor-not-allowed disabled:bg-neutral-100 dark:border-neutral-600 dark:bg-neutral-800 dark:text-neutral-100 dark:placeholder-neutral-500 dark:disabled:bg-neutral-700",
  inputError: "border-red-500! focus:border-red-500! focus:ring-red-500!",
  primaryButton:
    "inline-flex w-full items-center justify-center gap-2 rounded-lg bg-emerald-600 px-4 py-3 font-medium text-white transition-colors hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:focus:ring-offset-neutral-900",
  linkButton:
    "text-sm font-medium text-emerald-700 hover:text-emerald-800 hover:underline disabled:cursor-not-allowed disabled:text-neutral-400 disabled:no-underline dark:text-emerald-400 dark:hover:text-emerald-300 dark:disabled:text-neutral-500",
  error: "text-sm text-red-600 dark:text-red-400",
  divider:
    "flex items-center gap-3 text-xs uppercase tracking-wide text-neutral-400 before:h-px before:flex-1 before:bg-neutral-200 after:h-px after:flex-1 after:bg-neutral-200 dark:text-neutral-500 dark:before:bg-neutral-700 dark:after:bg-neutral-700",
};
